import api from '../../api/axios';
import { AUTH_VALIDATE_SUCCESS } from './validateAction';
import { showSuccess, showError } from '../../Components/reuse/Toast';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const clearAuthError = () => ({ type: CLEAR_AUTH_ERROR });

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });
    const response = await api.post(`auth/signin`, { email, password });
    const envelope = response.data; // expected: { success, message, data: <user>, token }
    const token = envelope?.token || envelope?.data?.token || null;
    const possibleUser = envelope?.data || envelope?.user || envelope?.data?.user || null;
    const user = possibleUser && possibleUser._id ? possibleUser : null;
    if (token) {
      localStorage.setItem('token', token);
      // Interceptor will attach Authorization for subsequent requests
    }
    dispatch({ type: LOGIN_SUCCESS, payload: { token } });
    if (user) {
      dispatch({ type: AUTH_VALIDATE_SUCCESS, payload: { user, token: token || localStorage.getItem('token') || null } });
    }
    showSuccess('Logged in successfully');
    return envelope;
  } catch (error) {
    const message = error?.response?.data?.message || 'Invalid email or password';
    dispatch({ type: LOGIN_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};

export const signup = (company, email, password, storeUrl, partner_id) => async (dispatch) => {
  try {
    dispatch({ type: SIGNUP_REQUEST });
    const response = await api.post(`auth/signup`, { company, email, password, storeUrl, partner_id });
    const data = response.data;
    dispatch({ type: SIGNUP_SUCCESS, payload: data });
    showSuccess('Account created successfully');
    return data;
  } catch (error) {
    const apiErrors = error?.response?.data?.errors;
    const backendMsg = error?.response?.data?.message;
    const message = (Array.isArray(apiErrors) && apiErrors.length > 0)
      ? apiErrors.map(e => e?.msg).filter(Boolean).join(', ')
      : (backendMsg || 'Signup failed');
    dispatch({ type: SIGNUP_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};
